import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { createSessionToken } from '@pkgs/api/utils';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { getPlaceDetailsForPropertyEngine, type Language, type PlaceDetailsExtended } from '@generated/search-bff';

export type GetPlaceDetailsForPropertyEngineOptions = {
  language: Language;
  sessionToken?: string;
};

/**
 * Fetch detailed location information for a given place ID using the `/api/v1/autosuggestion/property-engine/details` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/autosuggestion/getPropertyEnginePlaceDetails Search API Documentation}
 */
export async function getPropertyEnginePlaceDetails(
  placeId: string,
  { language, sessionToken }: GetPlaceDetailsForPropertyEngineOptions,
  apiConfig: ApiConfig,
): Promise<ApiResult<PlaceDetailsExtended>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'getPropertyEnginePlaceDetails');

    const result = await getPlaceDetailsForPropertyEngine(
      {
        placeId,
        language,
        sessionToken: sessionToken ?? createSessionToken(),
      },
      _apiConfig,
    );

    return {
      status: 'success',
      data: result,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
